export class EmailNotificationSettingModel {
    public PaymentEmailNotification: boolean;
    public DocumentEmailNotification: boolean;
    public SignedDocumentEmailNotification: boolean;
    public LocationemailNotification: boolean;
    public NewUserSignupEmailNotification: boolean;
}
